import { render, staticRenderFns } from "./RiwayatList.vue?vue&type=template&id=ec721cdc&"
import script from "./RiwayatList.vue?vue&type=script&lang=js&"
export * from "./RiwayatList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports